// Logo de FacturaPOS: el isotipo de la marca (el rayo en forma de F) y el
// nombre. Con withText={false} queda solo el isotipo (menu colapsado).

// Proporcion del isotipo (ancho / alto): reserva su lugar antes de que la
// imagen cargue, para que el menu no salte.
const PROPORCION_ISOTIPO = 204 / 256;

export default function Logo({ size = 36, withText = true }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
      <img
        src="/facturags-isotipo.webp"
        alt={withText ? '' : 'FacturaPOS'}
        width={Math.round(size * PROPORCION_ISOTIPO)}
        height={size}
        style={{ display: 'block', flexShrink: 0 }}
      />
      {withText && (
        <span style={{
          fontFamily: 'var(--font-display)', fontWeight: 700, fontSize: size * 0.5,
          letterSpacing: '-0.02em', color: 'var(--text)',
        }}>
          Factura<span style={{ color: 'var(--accent-vivo)' }}>POS</span>
        </span>
      )}
    </div>
  );
}
